import { useState, useEffect } from "react";
import { useTheme } from "../../../theme";
import { BRAND_COLORS } from "../../../theme/colors.js";
import { LogoStyles, SpinnerLogo } from "../../../logos";

export default function NavBrandSpinner({ onClick }) {
  const t = useTheme();
  const [index, setIndex] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setTransitioning(true);
      setTimeout(() => {
        setIndex((i) => (i + 1) % LogoStyles.length);
        setTransitioning(false);
      }, 250);
    }, 2800);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      onClick={onClick}
      style={{
        width: 72,
        height: 72,
        borderRadius: 14,
        border: "1px solid " + t.borderStrong,
        background: t.surfaceHover,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        cursor: "pointer",
        position: "relative",
        transition: "all 0.3s ease",
        flexShrink: 0,
        padding: 8,
      }}
    >
      <div style={{
        transform: transitioning ? "translateY(-10px) scale(0.6)" : "translateY(0) scale(1)",
        opacity: transitioning ? 0 : 1,
        transition: "all 0.25s cubic-bezier(0.16, 1, 0.3, 1)",
      }}>
        <SpinnerLogo style={LogoStyles[index]} size={50} theme={t} brand={BRAND_COLORS} />
      </div>
    </div>
  );
}
